import CheckmarkIcon from '~/components/Icons/svgs/CheckmarkIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'

export default function MustKnowTags({
  title,
  isSelected,
}: {
  title: string
  isSelected?: boolean
}): React.ReactElement {
  const stateClassName = isSelected ? 'bg-green-lime text-black' : 'bg-purple border-2 border-purple-300/40 text-white'

  return (
    <div className={`flex h-8 justify-center px-3 py-1.5 items-center ${stateClassName} rounded-full`}>
      <div className="flex justify-start items-start font-semibold text-xxxs gap-2 w-full h-full">
        <div className="flex flex-1 h-full justify-center items-center gap-2">
          {isSelected ? (
            <SVGIcon icon={CheckmarkIcon} pathClassName="text-black" size={12} />
          ) : (
            <div className="w-2.5 h-2.5 border-purple-lavender rounded-full border" />
          )}
          <span>🧩</span>
        </div>
        <p className="flex-grow w-full h-full flex justify-center items-center">{title}</p>
      </div>
    </div>
  )
}
